import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } };

  connect() {
    this.dismissTimeout = window.setTimeout(() => this.dismiss(), this.delayValue);
  }

  disconnect() {
    window.clearTimeout(this.dismissTimeout);
    window.clearTimeout(this.removeTimeout);
  }

  dismiss() {
    this.element.classList.add("toast-leaving");
    this.removeTimeout = window.setTimeout(() => this.element.remove(), 300);
  }
}
